import QueryString from 'qs';
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function NaverPay() {
  const locations = useLocation();
  useEffect(() => {
    const query = QueryString.parse(locations.search, {
      ignoreQueryPrefix: true,
    });
    if (query.naverUrl) {
      //@ts-ignore
      window.location.href = JSON.parse(query.naverUrl);
    }
  }, []);
  return <></>;
}
